export default {
  GENERAL: {
    LOAD_COMMON_REPLIES: 'LOAD_COMMON_REPLIES',
    LOAD_INTENT_MESSAGES: 'LOAD_INTENT_MESSAGES',
    SET_FREQUENTLY_USED_DETAILS: 'SET_FREQUENTLY_USED_DETAILS',
    LOAD_KEYWORDS: 'LOAD_KEYWORDS'
  },
  SESSIONS: {
    POPULATE_SESSIONS: 'POPULATE_SESSIONS',
    MODIFY_SESSION: 'MODIFY_SESSION',
    REMOVE_SESSION: 'REMOVE_SESSION',
    ADD_SESSION: 'ADD_SESSION'
  },
  CHAT: {
    ADD_MESSAGE: 'ADD_MESSAGE',
    MODIFY_MESSAGE: 'MODIFY_MESSAGE'
  },
  PROFILE: {
    SET_PROFILE: 'SET_PROFILE'
  },
  SLACK: {
    LOAD_SMS_APPS: 'LOAD_SMS_APPS'
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations/mutation-types.js